module.exports = __webpack_public_path__ + "img/yz.e56e7175.png";